<template>
  <!-- 温馨提示弹框 -->
  <div class="page-popup-container" @click="doClose()">
    <div class="page-popup-main" @click.stop="">
      <!-- <img :src="require('@/assets/images/pagePopup.png')" alt=""> -->
      <div class="page-popup-content">
        <slot name="title">
          <div class="page-popup-title">
            {{ popupInfo.title }}
          </div>
        </slot>
        <slot name="content">
          <div
            class="page-popup-message"
            v-for="content in popupInfo.content"
            :key="content"
            v-html="content"
          ></div>
        </slot>
      </div>
      <div class="page-popup-button-group">
        <div
          class="page-popup-button global-center"
          @click="doCancel"
          v-if="popupInfo.showCancel"
        >
          {{ popupInfo.cancelText }}
        </div>
        <div
          class="page-popup-button global-center"
          @click="doComfirm"
          v-if="popupInfo.showComfirm"
        >
          {{ popupInfo.comfirmText }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    doCancel: {
      type: Function,
      default: () => {},
    },
    doComfirm: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      popupInfo: {
        title: "温馨提示",
        content: [],
        cancelText: "取消",
        showCancel: true,
        comfirmText: "确认",
        showComfirm: true,
        isFullScreenClose: true, // 是否支持全屏关闭
      },
    };
  },
  created() {
    this.popupInfo = {
      ...this.popupInfo,
      ...this.data,
    };
  },
  mounted() {},
  methods: {
    doClose() {
      if (!this.popupInfo.isFullScreenClose) return;
      this.doCancel();
    },
  },
};
</script>
<style>
.page-popup-container {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
  line-height: 1.5;
  background: rgba(153, 153, 153, 0.5);
}
.page-popup-main {
  width: 335px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.page-popup-main img {
  width: 100%;
  height: auto;
}
.page-popup-content {
  flex: 1 0 0;
  padding: 30px;
  text-align: center;
}
.page-popup-title {
  font-size: 16px;
  color: #f26649;
  text-align: center;
  margin-bottom: 15px;
  font-weight: 700;
}
.page-popup-message {
  font-size: 12px;
  line-height: 22px;
  /* text-indent: 24px; */
  width: 268px;
  font-weight: 400;
  color: #221815;
}
.page-popup-button-group {
  width: 100%;
  height: 46px;
  color: #f26649;
  display: flex;
  border-top: 1px solid #ededed;
}
.page-popup-button:nth-child(2) {
  border-left: 1px solid #ededed;
}
.page-popup-button {
  flex: 1 0 0;
  font-weight: 400;
  font-size: 13px;
}
</style>